var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4559 2.5543C11.0392 1.8783 11.4323 0.936784 11.3247 0C10.4842 0.032 9.46738 0.536917 8.86471 1.21211C8.32352 1.8113 7.85109 2.76872 7.97809 3.68711C8.91568 3.7567 9.87267 3.23108 10.4559 2.5543ZM12.5584 8.5C12.5819 10.9216 14.7749 11.7271 14.7992 11.7375C14.7814 11.7943 14.4489 12.8853 13.644 14.0133C12.9475 14.9877 12.2251 15.9581 11.0869 15.9789C9.96894 15.9989 9.60895 15.3438 8.32999 15.3438C7.05184 15.3438 6.65221 15.958 5.5941 15.9988C4.49553 16.038 3.65826 14.9446 2.9569 13.9734C1.52181 11.9871 0.425671 8.36007 1.89797 5.91211C2.62927 4.69693 3.93573 3.92623 5.35464 3.90703C6.43298 3.88703 7.45146 4.60234 8.11076 4.60234C8.77006 4.60234 10.0078 3.74235 11.3086 3.86875C11.853 3.89035 13.3819 4.07908 14.3632 5.45586C14.2839 5.50306 12.539 6.47603 12.5584 8.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "res/media/apple.044f8f551bdf53ed44e52a24999fff13.svg";
export { ForwardRef as ReactComponent };